if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }
   
      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.handledropDown();
        this.attachVariantFilters();
      }
      
      handledropDown() {
        
          var SimpleBar=function(){"use strict";var e=function(t,i){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i])},e(t,i)};var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};var i=function(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)},s="object"==typeof t&&t&&t.Object===Object&&t,r="object"==typeof self&&self&&self.Object===Object&&self,l=s||r||Function("return this")(),o=l,n=function(){return o.Date.now()},a=/\s/;var c=function(e){for(var t=e.length;t--&&a.test(e.charAt(t)););return t},h=/^\s+/;var u=function(e){return e?e.slice(0,c(e)+1).replace(h,""):e},d=l.Symbol,p=d,v=Object.prototype,f=v.hasOwnProperty,m=v.toString,b=p?p.toStringTag:void 0;var g=function(e){var t=f.call(e,b),i=e[b];try{e[b]=void 0;var s=!0}catch(e){}var r=m.call(e);return s&&(t?e[b]=i:delete e[b]),r},x=Object.prototype.toString;var y=g,E=function(e){return x.call(e)},w=d?d.toStringTag:void 0;var O=function(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":w&&w in Object(e)?y(e):E(e)},S=function(e){return null!=e&&"object"==typeof e};var A=u,k=i,W=function(e){return"symbol"==typeof e||S(e)&&"[object Symbol]"==O(e)},M=/^[-+]0x[0-9a-f]+$/i,N=/^0b[01]+$/i,L=/^0o[0-7]+$/i,z=parseInt;var C=i,T=n,D=function(e){if("number"==typeof e)return e;if(W(e))return NaN;if(k(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=k(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=A(e);var i=N.test(e);return i||L.test(e)?z(e.slice(2),i?2:8):M.test(e)?NaN:+e},R=Math.max,V=Math.min;var H=function(e,t,i){var s,r,l,o,n,a,c=0,h=!1,u=!1,d=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function p(t){var i=s,l=r;return s=r=void 0,c=t,o=e.apply(l,i)}function v(e){return c=e,n=setTimeout(m,t),h?p(e):o}function f(e){var i=e-a;return void 0===a||i>=t||i<0||u&&e-c>=l}function m(){var e=T();if(f(e))return b(e);n=setTimeout(m,function(e){var i=t-(e-a);return u?V(i,l-(e-c)):i}(e))}function b(e){return n=void 0,d&&s?p(e):(s=r=void 0,o)}function g(){var e=T(),i=f(e);if(s=arguments,r=this,a=e,i){if(void 0===n)return v(a);if(u)return clearTimeout(n),n=setTimeout(m,t),p(a)}return void 0===n&&(n=setTimeout(m,t)),o}return t=D(t)||0,C(i)&&(h=!!i.leading,l=(u="maxWait"in i)?R(D(i.maxWait)||0,t):l,d="trailing"in i?!!i.trailing:d),g.cancel=function(){void 0!==n&&clearTimeout(n),c=0,s=a=r=n=void 0},g.flush=function(){return void 0===n?o:b(T())},g},j=H,B=i;var _=function(e,t,i){var s=!0,r=!0;if("function"!=typeof e)throw new TypeError("Expected a function");return B(i)&&(s="leading"in i?!!i.leading:s,r="trailing"in i?!!i.trailing:r),j(e,t,{leading:s,maxWait:t,trailing:r})},q=function(){return q=Object.assign||function(e){for(var t,i=1,s=arguments.length;i<s;i++)for(var r in t=arguments[i])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},q.apply(this,arguments)};function P(e){return e&&e.ownerDocument&&e.ownerDocument.defaultView?e.ownerDocument.defaultView:window}function X(e){return e&&e.ownerDocument?e.ownerDocument:document}var Y=function(e){return Array.prototype.reduce.call(e,(function(e,t){var i=t.name.match(/data-simplebar-(.+)/);if(i){var s=i[1].replace(/\W+(.)/g,(function(e,t){return t.toUpperCase()}));switch(t.value){case"true":e[s]=!0;break;case"false":e[s]=!1;break;case void 0:e[s]=!0;break;default:e[s]=t.value}}return e}),{})};function F(e,t){var i;e&&(i=e.classList).add.apply(i,t.split(" "))}function I(e,t){e&&t.split(" ").forEach((function(t){e.classList.remove(t)}))}function U(e){return".".concat(e.split(" ").join("."))}var $=!("undefined"==typeof window||!window.document||!window.document.createElement),Z=Object.freeze({__proto__:null,addClasses:F,canUseDOM:$,classNamesToQuery:U,getElementDocument:X,getElementWindow:P,getOptions:Y,removeClasses:I}),Q=null,G=null;function J(){if(null===Q){if("undefined"==typeof document)return Q=0;var e=document.body,t=document.createElement("div");t.classList.add("simplebar-hide-scrollbar"),e.appendChild(t);var i=t.getBoundingClientRect().right;e.removeChild(t),Q=i}return Q}$&&window.addEventListener("resize",(function(){G!==window.devicePixelRatio&&(G=window.devicePixelRatio,Q=null)}));var K=P,ee=X,te=Y,ie=F,se=I,re=U,le=function(){function e(t,i){void 0===i&&(i={});var s=this;if(this.removePreventClickId=null,this.minScrollbarWidth=20,this.stopScrollDelay=175,this.isScrolling=!1,this.isMouseEntering=!1,this.isDragging=!1,this.scrollXTicking=!1,this.scrollYTicking=!1,this.wrapperEl=null,this.contentWrapperEl=null,this.contentEl=null,this.offsetEl=null,this.maskEl=null,this.placeholderEl=null,this.heightAutoObserverWrapperEl=null,this.heightAutoObserverEl=null,this.rtlHelpers=null,this.scrollbarWidth=0,this.resizeObserver=null,this.mutationObserver=null,this.elStyles=null,this.isRtl=null,this.mouseX=0,this.mouseY=0,this.onMouseMove=function(){},this.onWindowResize=function(){},this.onStopScrolling=function(){},this.onMouseEntered=function(){},this.onScroll=function(){var e=K(s.el);s.scrollXTicking||(e.requestAnimationFrame(s.scrollX),s.scrollXTicking=!0),s.scrollYTicking||(e.requestAnimationFrame(s.scrollY),s.scrollYTicking=!0),s.isScrolling||(s.isScrolling=!0,ie(s.el,s.classNames.scrolling)),s.showScrollbar("x"),s.showScrollbar("y"),s.onStopScrolling()},this.scrollX=function(){s.axis.x.isOverflowing&&s.positionScrollbar("x"),s.scrollXTicking=!1},this.scrollY=function(){s.axis.y.isOverflowing&&s.positionScrollbar("y"),s.scrollYTicking=!1},this._onStopScrolling=function(){se(s.el,s.classNames.scrolling),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isScrolling=!1},this.onMouseEnter=function(){s.isMouseEntering||(ie(s.el,s.classNames.mouseEntered),s.showScrollbar("x"),s.showScrollbar("y"),s.isMouseEntering=!0),s.onMouseEntered()},this._onMouseEntered=function(){se(s.el,s.classNames.mouseEntered),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isMouseEntering=!1},this._onMouseMove=function(e){s.mouseX=e.clientX,s.mouseY=e.clientY,(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseMoveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseMoveForAxis("y")},this.onMouseLeave=function(){s.onMouseMove.cancel(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseLeaveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseLeaveForAxis("y"),s.mouseX=-1,s.mouseY=-1},this._onWindowResize=function(){s.scrollbarWidth=s.getScrollbarWidth(),s.hideNativeScrollbar()},this.onPointerEvent=function(e){var t,i;s.axis.x.track.el&&s.axis.y.track.el&&s.axis.x.scrollbar.el&&s.axis.y.scrollbar.el&&(s.axis.x.track.rect=s.axis.x.track.el.getBoundingClientRect(),s.axis.y.track.rect=s.axis.y.track.el.getBoundingClientRect(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&(t=s.isWithinBounds(s.axis.x.track.rect)),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&(i=s.isWithinBounds(s.axis.y.track.rect)),(t||i)&&(e.stopPropagation(),"pointerdown"===e.type&&"touch"!==e.pointerType&&(t&&(s.axis.x.scrollbar.rect=s.axis.x.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.x.scrollbar.rect)?s.onDragStart(e,"x"):s.onTrackClick(e,"x")),i&&(s.axis.y.scrollbar.rect=s.axis.y.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.y.scrollbar.rect)?s.onDragStart(e,"y"):s.onTrackClick(e,"y")))))},this.drag=function(t){var i,r,l,o,n,a,c,h,u,d,p;if(s.draggedAxis&&s.contentWrapperEl){var v=s.axis[s.draggedAxis].track,f=null!==(r=null===(i=v.rect)||void 0===i?void 0:i[s.axis[s.draggedAxis].sizeAttr])&&void 0!==r?r:0,m=s.axis[s.draggedAxis].scrollbar,b=null!==(o=null===(l=s.contentWrapperEl)||void 0===l?void 0:l[s.axis[s.draggedAxis].scrollSizeAttr])&&void 0!==o?o:0,g=parseInt(null!==(a=null===(n=s.elStyles)||void 0===n?void 0:n[s.axis[s.draggedAxis].sizeAttr])&&void 0!==a?a:"0px",10);t.preventDefault(),t.stopPropagation();var x=("y"===s.draggedAxis?t.pageY:t.pageX)-(null!==(h=null===(c=v.rect)||void 0===c?void 0:c[s.axis[s.draggedAxis].offsetAttr])&&void 0!==h?h:0)-s.axis[s.draggedAxis].dragOffset,y=(x="x"===s.draggedAxis&&s.isRtl?(null!==(d=null===(u=v.rect)||void 0===u?void 0:u[s.axis[s.draggedAxis].sizeAttr])&&void 0!==d?d:0)-m.size-x:x)/(f-m.size)*(b-g);"x"===s.draggedAxis&&s.isRtl&&(y=(null===(p=e.getRtlHelpers())||void 0===p?void 0:p.isScrollingToNegative)?-y:y),s.contentWrapperEl[s.axis[s.draggedAxis].scrollOffsetAttr]=y}},this.onEndDrag=function(e){s.isDragging=!1;var t=ee(s.el),i=K(s.el);e.preventDefault(),e.stopPropagation(),se(s.el,s.classNames.dragging),s.onStopScrolling(),t.removeEventListener("mousemove",s.drag,!0),t.removeEventListener("mouseup",s.onEndDrag,!0),s.removePreventClickId=i.setTimeout((function(){t.removeEventListener("click",s.preventClick,!0),t.removeEventListener("dblclick",s.preventClick,!0),s.removePreventClickId=null}))},this.preventClick=function(e){e.preventDefault(),e.stopPropagation()},this.el=t,this.options=q(q({},e.defaultOptions),i),this.classNames=q(q({},e.defaultOptions.classNames),i.classNames),this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetSizeAttr:"offsetWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetSizeAttr:"offsetHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}}},"object"!=typeof this.el||!this.el.nodeName)throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));this.onMouseMove=_(this._onMouseMove,64),this.onWindowResize=H(this._onWindowResize,64,{leading:!0}),this.onStopScrolling=H(this._onStopScrolling,this.stopScrollDelay),this.onMouseEntered=H(this._onMouseEntered,this.stopScrollDelay),this.init()}return e.getRtlHelpers=function(){if(e.rtlHelpers)return e.rtlHelpers;var t=document.createElement("div");t.innerHTML='<div class="simplebar-dummy-scrollbar-size"><div></div></div>';var i=t.firstElementChild,s=null==i?void 0:i.firstElementChild;if(!s)return null;document.body.appendChild(i),i.scrollLeft=0;var r=e.getOffset(i),l=e.getOffset(s);i.scrollLeft=-999;var o=e.getOffset(s);return document.body.removeChild(i),e.rtlHelpers={isScrollOriginAtZero:r.left!==l.left,isScrollingToNegative:l.left!==o.left},e.rtlHelpers},e.prototype.getScrollbarWidth=function(){try{return this.contentWrapperEl&&"none"===getComputedStyle(this.contentWrapperEl,"::-webkit-scrollbar").display||"scrollbarWidth"in document.documentElement.style||"-ms-overflow-style"in document.documentElement.style?0:J()}catch(e){return J()}},e.getOffset=function(e){var t=e.getBoundingClientRect(),i=ee(e),s=K(e);return{top:t.top+(s.pageYOffset||i.documentElement.scrollTop),left:t.left+(s.pageXOffset||i.documentElement.scrollLeft)}},e.prototype.init=function(){$&&(this.initDOM(),this.rtlHelpers=e.getRtlHelpers(),this.scrollbarWidth=this.getScrollbarWidth(),this.recalculate(),this.initListeners())},e.prototype.initDOM=function(){var e,t;this.wrapperEl=this.el.querySelector(re(this.classNames.wrapper)),this.contentWrapperEl=this.options.scrollableNode||this.el.querySelector(re(this.classNames.contentWrapper)),this.contentEl=this.options.contentNode||this.el.querySelector(re(this.classNames.contentEl)),this.offsetEl=this.el.querySelector(re(this.classNames.offset)),this.maskEl=this.el.querySelector(re(this.classNames.mask)),this.placeholderEl=this.findChild(this.wrapperEl,re(this.classNames.placeholder)),this.heightAutoObserverWrapperEl=this.el.querySelector(re(this.classNames.heightAutoObserverWrapperEl)),this.heightAutoObserverEl=this.el.querySelector(re(this.classNames.heightAutoObserverEl)),this.axis.x.track.el=this.findChild(this.el,"".concat(re(this.classNames.track)).concat(re(this.classNames.horizontal))),this.axis.y.track.el=this.findChild(this.el,"".concat(re(this.classNames.track)).concat(re(this.classNames.vertical))),this.axis.x.scrollbar.el=(null===(e=this.axis.x.track.el)||void 0===e?void 0:e.querySelector(re(this.classNames.scrollbar)))||null,this.axis.y.scrollbar.el=(null===(t=this.axis.y.track.el)||void 0===t?void 0:t.querySelector(re(this.classNames.scrollbar)))||null,this.options.autoHide||(ie(this.axis.x.scrollbar.el,this.classNames.visible),ie(this.axis.y.scrollbar.el,this.classNames.visible))},e.prototype.initListeners=function(){var e,t=this,i=K(this.el);if(this.el.addEventListener("mouseenter",this.onMouseEnter),this.el.addEventListener("pointerdown",this.onPointerEvent,!0),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),null===(e=this.contentWrapperEl)||void 0===e||e.addEventListener("scroll",this.onScroll),i.addEventListener("resize",this.onWindowResize),this.contentEl){if(window.ResizeObserver){var s=!1,r=i.ResizeObserver||ResizeObserver;this.resizeObserver=new r((function(){s&&i.requestAnimationFrame((function(){t.recalculate()}))})),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl),i.requestAnimationFrame((function(){s=!0}))}this.mutationObserver=new i.MutationObserver((function(){i.requestAnimationFrame((function(){t.recalculate()}))})),this.mutationObserver.observe(this.contentEl,{childList:!0,subtree:!0,characterData:!0})}},e.prototype.recalculate=function(){if(this.heightAutoObserverEl&&this.contentEl&&this.contentWrapperEl&&this.wrapperEl&&this.placeholderEl){var e=K(this.el);this.elStyles=e.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction;var t=this.contentEl.offsetWidth,i=this.heightAutoObserverEl.offsetHeight<=1,s=this.heightAutoObserverEl.offsetWidth<=1||t>0,r=this.contentWrapperEl.offsetWidth,l=this.elStyles.overflowX,o=this.elStyles.overflowY;this.contentEl.style.padding="".concat(this.elStyles.paddingTop," ").concat(this.elStyles.paddingRight," ").concat(this.elStyles.paddingBottom," ").concat(this.elStyles.paddingLeft),this.wrapperEl.style.margin="-".concat(this.elStyles.paddingTop," -").concat(this.elStyles.paddingRight," -").concat(this.elStyles.paddingBottom," -").concat(this.elStyles.paddingLeft);var n=this.contentEl.scrollHeight,a=this.contentEl.scrollWidth;this.contentWrapperEl.style.height=i?"auto":"100%",this.placeholderEl.style.width=s?"".concat(t||a,"px"):"auto",this.placeholderEl.style.height="".concat(n,"px");var c=this.contentWrapperEl.offsetHeight;this.axis.x.isOverflowing=0!==t&&a>t,this.axis.y.isOverflowing=n>c,this.axis.x.isOverflowing="hidden"!==l&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==o&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar();var h=this.axis.x.isOverflowing?this.scrollbarWidth:0,u=this.axis.y.isOverflowing?this.scrollbarWidth:0;this.axis.x.isOverflowing=this.axis.x.isOverflowing&&a>r-u,this.axis.y.isOverflowing=this.axis.y.isOverflowing&&n>c-h,this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el&&(this.axis.x.scrollbar.el.style.width="".concat(this.axis.x.scrollbar.size,"px")),this.axis.y.scrollbar.el&&(this.axis.y.scrollbar.el.style.height="".concat(this.axis.y.scrollbar.size,"px")),this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")}},e.prototype.getScrollbarSize=function(e){var t,i;if(void 0===e&&(e="y"),!this.axis[e].isOverflowing||!this.contentEl)return 0;var s,r=this.contentEl[this.axis[e].scrollSizeAttr],l=null!==(i=null===(t=this.axis[e].track.el)||void 0===t?void 0:t[this.axis[e].offsetSizeAttr])&&void 0!==i?i:0,o=l/r;return s=Math.max(~~(o*l),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(s=Math.min(s,this.options.scrollbarMaxSize)),s},e.prototype.positionScrollbar=function(t){var i,s,r;void 0===t&&(t="y");var l=this.axis[t].scrollbar;if(this.axis[t].isOverflowing&&this.contentWrapperEl&&l.el&&this.elStyles){var o=this.contentWrapperEl[this.axis[t].scrollSizeAttr],n=(null===(i=this.axis[t].track.el)||void 0===i?void 0:i[this.axis[t].offsetSizeAttr])||0,a=parseInt(this.elStyles[this.axis[t].sizeAttr],10),c=this.contentWrapperEl[this.axis[t].scrollOffsetAttr];c="x"===t&&this.isRtl&&(null===(s=e.getRtlHelpers())||void 0===s?void 0:s.isScrollOriginAtZero)?-c:c,"x"===t&&this.isRtl&&(c=(null===(r=e.getRtlHelpers())||void 0===r?void 0:r.isScrollingToNegative)?c:-c);var h=c/(o-a),u=~~((n-l.size)*h);u="x"===t&&this.isRtl?-u+(n-l.size):u,l.el.style.transform="x"===t?"translate3d(".concat(u,"px, 0, 0)"):"translate3d(0, ".concat(u,"px, 0)")}},e.prototype.toggleTrackVisibility=function(e){void 0===e&&(e="y");var t=this.axis[e].track.el,i=this.axis[e].scrollbar.el;t&&i&&this.contentWrapperEl&&(this.axis[e].isOverflowing||this.axis[e].forceVisible?(t.style.visibility="visible",this.contentWrapperEl.style[this.axis[e].overflowAttr]="scroll",this.el.classList.add("".concat(this.classNames.scrollable,"-").concat(e))):(t.style.visibility="hidden",this.contentWrapperEl.style[this.axis[e].overflowAttr]="hidden",this.el.classList.remove("".concat(this.classNames.scrollable,"-").concat(e))),this.axis[e].isOverflowing?i.style.display="block":i.style.display="none")},e.prototype.showScrollbar=function(e){void 0===e&&(e="y"),this.axis[e].isOverflowing&&!this.axis[e].scrollbar.isVisible&&(ie(this.axis[e].scrollbar.el,this.classNames.visible),this.axis[e].scrollbar.isVisible=!0)},e.prototype.hideScrollbar=function(e){void 0===e&&(e="y"),this.isDragging||this.axis[e].isOverflowing&&this.axis[e].scrollbar.isVisible&&(se(this.axis[e].scrollbar.el,this.classNames.visible),this.axis[e].scrollbar.isVisible=!1)},e.prototype.hideNativeScrollbar=function(){this.offsetEl&&(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px",this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px")},e.prototype.onMouseMoveForAxis=function(e){void 0===e&&(e="y");var t=this.axis[e];t.track.el&&t.scrollbar.el&&(t.track.rect=t.track.el.getBoundingClientRect(),t.scrollbar.rect=t.scrollbar.el.getBoundingClientRect(),this.isWithinBounds(t.track.rect)?(this.showScrollbar(e),ie(t.track.el,this.classNames.hover),this.isWithinBounds(t.scrollbar.rect)?ie(t.scrollbar.el,this.classNames.hover):se(t.scrollbar.el,this.classNames.hover)):(se(t.track.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(e)))},e.prototype.onMouseLeaveForAxis=function(e){void 0===e&&(e="y"),se(this.axis[e].track.el,this.classNames.hover),se(this.axis[e].scrollbar.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(e)},e.prototype.onDragStart=function(e,t){var i;void 0===t&&(t="y"),this.isDragging=!0;var s=ee(this.el),r=K(this.el),l=this.axis[t].scrollbar,o="y"===t?e.pageY:e.pageX;this.axis[t].dragOffset=o-((null===(i=l.rect)||void 0===i?void 0:i[this.axis[t].offsetAttr])||0),this.draggedAxis=t,ie(this.el,this.classNames.dragging),s.addEventListener("mousemove",this.drag,!0),s.addEventListener("mouseup",this.onEndDrag,!0),null===this.removePreventClickId?(s.addEventListener("click",this.preventClick,!0),s.addEventListener("dblclick",this.preventClick,!0)):(r.clearTimeout(this.removePreventClickId),this.removePreventClickId=null)},e.prototype.onTrackClick=function(e,t){var i,s,r,l,o=this;void 0===t&&(t="y");var n=this.axis[t];if(this.options.clickOnTrack&&n.scrollbar.el&&this.contentWrapperEl){e.preventDefault();var a=K(this.el);this.axis[t].scrollbar.rect=n.scrollbar.el.getBoundingClientRect();var c=null!==(s=null===(i=this.axis[t].scrollbar.rect)||void 0===i?void 0:i[this.axis[t].offsetAttr])&&void 0!==s?s:0,h=parseInt(null!==(l=null===(r=this.elStyles)||void 0===r?void 0:r[this.axis[t].sizeAttr])&&void 0!==l?l:"0px",10),u=this.contentWrapperEl[this.axis[t].scrollOffsetAttr],d=("y"===t?this.mouseY-c:this.mouseX-c)<0?-1:1,p=-1===d?u-h:u+h,v=function(){o.contentWrapperEl&&(-1===d?u>p&&(u-=40,o.contentWrapperEl[o.axis[t].scrollOffsetAttr]=u,a.requestAnimationFrame(v)):u<p&&(u+=40,o.contentWrapperEl[o.axis[t].scrollOffsetAttr]=u,a.requestAnimationFrame(v)))};v()}},e.prototype.getContentElement=function(){return this.contentEl},e.prototype.getScrollElement=function(){return this.contentWrapperEl},e.prototype.removeListeners=function(){var e=K(this.el);this.el.removeEventListener("mouseenter",this.onMouseEnter),this.el.removeEventListener("pointerdown",this.onPointerEvent,!0),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl&&this.contentWrapperEl.removeEventListener("scroll",this.onScroll),e.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver&&this.resizeObserver.disconnect(),this.onMouseMove.cancel(),this.onWindowResize.cancel(),this.onStopScrolling.cancel(),this.onMouseEntered.cancel()},e.prototype.unMount=function(){this.removeListeners()},e.prototype.isWithinBounds=function(e){return this.mouseX>=e.left&&this.mouseX<=e.left+e.width&&this.mouseY>=e.top&&this.mouseY<=e.top+e.height},e.prototype.findChild=function(e,t){var i=e.matches||e.webkitMatchesSelector||e.mozMatchesSelector||e.msMatchesSelector;return Array.prototype.filter.call(e.children,(function(e){return i.call(e,t)}))[0]},e.rtlHelpers=null,e.defaultOptions={forceVisible:!1,clickOnTrack:!0,scrollbarMinSize:25,scrollbarMaxSize:0,ariaLabel:"scrollable content",tabIndex:0,classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging",scrolling:"simplebar-scrolling",scrollable:"simplebar-scrollable",mouseEntered:"simplebar-mouse-entered"},scrollableNode:null,contentNode:null,autoHide:!0},e.getOptions=te,e.helpers=Z,e}(),oe=le.helpers,ne=oe.getOptions,ae=oe.addClasses,ce=oe.canUseDOM,he=function(t){function i(){for(var e=[],s=0;s<arguments.length;s++)e[s]=arguments[s];var r=t.apply(this,e)||this;return i.instances.set(e[0],r),r}return function(t,i){if("function"!=typeof i&&null!==i)throw new TypeError("Class extends value "+String(i)+" is not a constructor or null");function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}(i,t),i.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"),(function(e){"init"===e.getAttribute("data-simplebar")||i.instances.has(e)||new i(e,ne(e.attributes))}))},i.removeObserver=function(){var e;null===(e=i.globalObserver)||void 0===e||e.disconnect()},i.prototype.initDOM=function(){var e,t,i,s=this;if(!Array.prototype.filter.call(this.el.children,(function(e){return e.classList.contains(s.classNames.wrapper)})).length){for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),ae(this.wrapperEl,this.classNames.wrapper),ae(this.contentWrapperEl,this.classNames.contentWrapper),ae(this.offsetEl,this.classNames.offset),ae(this.maskEl,this.classNames.mask),ae(this.contentEl,this.classNames.contentEl),ae(this.placeholderEl,this.classNames.placeholder),ae(this.heightAutoObserverWrapperEl,this.classNames.heightAutoObserverWrapperEl),ae(this.heightAutoObserverEl,this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl),null===(e=this.contentWrapperEl)||void 0===e||e.setAttribute("tabindex",this.options.tabIndex.toString()),null===(t=this.contentWrapperEl)||void 0===t||t.setAttribute("role","region"),null===(i=this.contentWrapperEl)||void 0===i||i.setAttribute("aria-label",this.options.ariaLabel)}if(!this.axis.x.track.el||!this.axis.y.track.el){var r=document.createElement("div"),l=document.createElement("div");ae(r,this.classNames.track),ae(l,this.classNames.scrollbar),r.appendChild(l),this.axis.x.track.el=r.cloneNode(!0),ae(this.axis.x.track.el,this.classNames.horizontal),this.axis.y.track.el=r.cloneNode(!0),ae(this.axis.y.track.el,this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}le.prototype.initDOM.call(this),this.el.setAttribute("data-simplebar","init")},i.prototype.unMount=function(){le.prototype.unMount.call(this),i.instances.delete(this.el)},i.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(i.handleMutations),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},i.handleMutations=function(e){e.forEach((function(e){e.addedNodes.forEach((function(e){1===e.nodeType&&(e.hasAttribute("data-simplebar")?!i.instances.has(e)&&document.documentElement.contains(e)&&new i(e,ne(e.attributes)):e.querySelectorAll("[data-simplebar]").forEach((function(e){"init"!==e.getAttribute("data-simplebar")&&!i.instances.has(e)&&document.documentElement.contains(e)&&new i(e,ne(e.attributes))})))})),e.removedNodes.forEach((function(e){var t;1===e.nodeType&&("init"===e.getAttribute("data-simplebar")?!document.documentElement.contains(e)&&(null===(t=i.instances.get(e))||void 0===t||t.unMount()):Array.prototype.forEach.call(e.querySelectorAll('[data-simplebar="init"]'),(function(e){var t;!document.documentElement.contains(e)&&(null===(t=i.instances.get(e))||void 0===t||t.unMount())})))}))}))},i.instances=new WeakMap,i}(le);return ce&&he.initHtmlApi(),he}();
          const customDropdown = this.querySelector('custom-dropdown');
        
          customDropdown?.querySelector('.product_variant_dropdown_main_new')?.addEventListener("click", (event)=> {
            customDropdown.classList.toggle('open');
            this.classList.toggle('custom-dropdown-open');
          });
          document.addEventListener("click", (event) => {
           if(event.target.closest('custom-dropdown') != customDropdown) {
              customDropdown.classList.remove('open');
              this.classList.remove('custom-dropdown-open');
           }
          });
         
          this.querySelectorAll('.customScroll').forEach((item)=> {
           new SimpleBar(item);
        });
        
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {

        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
        
      }

      checkVariantFilters() {
        if (document.querySelectorAll('.product-variant-filter__value.active').length > 0) {
          const filterValue = document.querySelectorAll('.product-variant-filter__value.active')[0].getAttribute('filter-value');
          const swatches = document.querySelectorAll('.js-shade-swatch');
          const dropdownItems = document.querySelectorAll('.js-dropdown-item');

          // Filter swatches
          swatches.forEach(swatch => {
              const swatchFilterValue = swatch.getAttribute('filter-value');
              
              if (filterValue === 'All') {
                  // Show all swatches
                  swatch.style.display = '';
              } else if (swatchFilterValue === filterValue) {
                  console.log(swatchFilterValue)
                  // Show matching swatches
                  swatch.style.display = '';
              } else {
                  // Hide non-matching swatches
                  swatch.style.display = 'none';
              }
          });

          // Filter dropdown items
          dropdownItems.forEach(item => {
              const dropdownFilterValue = item.getAttribute('filter-value');
              
              if (filterValue === 'All') {
                  // Show all dropdown items
                  item.style.display = '';
              } else if (dropdownFilterValue === filterValue) {
                  // Show matching dropdown items
                  item.style.display = '';
              } else {
                  // Hide non-matching dropdown items
                  item.style.display = 'none';
              }
          });
        }
      }

      attachVariantFilters() {
        if (document.querySelectorAll('.product-variant-filter__value').length > 0) {
          const filterButtons = document.querySelectorAll('.product-variant-filter__value');
          const swatches = document.querySelectorAll('.js-shade-swatch');
          const dropdownItems = document.querySelectorAll('.js-dropdown-item');

          filterButtons.forEach(button => {
              button.addEventListener('click', function() {
                
                  // Get the filter value
                  const filterValue = this.getAttribute('filter-value');

                  // var filterSelected = false;

                  // Remove active class from all buttons
                  filterButtons.forEach(btn => btn.classList.remove('active'));
                  
                  // Add active class to clicked button
                  this.classList.add('active');
                  
                  // Filter swatches
                  swatches.forEach(swatch => {
                      const swatchFilterValue = swatch.getAttribute('filter-value');
                      
                      if (filterValue === 'All') {
                          // Show all swatches
                          swatch.style.display = '';
                      } else if (swatchFilterValue === filterValue) {
                          // Show matching swatches
                          swatch.style.display = '';
                      } else {
                          // Hide non-matching swatches
                          swatch.style.display = 'none';
                      }
                  });

                  // Filter dropdown items
                  dropdownItems.forEach(item => {
                      const dropdownFilterValue = item.getAttribute('filter-value');
                      
                      if (filterValue === 'All') {
                          // Show all dropdown items
                          item.style.display = '';
                      } else if (dropdownFilterValue === filterValue) {
                          // Show matching dropdown items
                          item.style.display = '';
                      } else {
                          // Hide non-matching dropdown items
                          item.style.display = 'none';
                      }
                  });

                  // Select swatch from active filter
                  var filterSelected = false;

                  document.querySelectorAll('.js-shade-swatch').forEach(swatch => {
                    if (swatch.style.display === 'none' && filterSelected == false) {
                    } else if (filterSelected == false) {
                      swatch.click();
                      filterSelected = true;
                    }
                  });

              });

          });
        }
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
          if(hueClassName){
            document.querySelectorAll(hueClassName)?.forEach(function(el) {
              el.style.display = 'block';
            });
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        document.dispatchEvent(new CustomEvent('selectedVariant:init', { detail: selectedVariant }))
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        if(document.body.classList.contains('collection-bundle')) {
          !shouldFetchFullPage && params.push("target=bundle");
        } else {
          !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        }
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          if(!document.body.classList.contains('collection-bundle')) {
            this.updateURL(productUrl, variant?.id);
          }
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('price2');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));


          updateSourceFromDestination('BISTrigger');
          if(typeof initializeKlaviyoTrigger != undefined) initializeKlaviyoTrigger();
          
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          if(hueClassName){
            document.querySelectorAll(hueClassName)?.forEach(function(el) {
              el.style.display = 'block';
            });
          }

           const addBtnSource = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
           const addBtnDestination = this.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
          if(addBtnSource && addBtnDestination) {
            addBtnDestination.className = addBtnSource.className;
          }
          
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

           //===========Change sticky input
           this.querySelectorAll('.product-form__input').forEach((item, index)=> {
            const optionValue = item.querySelector('input:checked')?.getAttribute('data-option-value-id');
            if(optionValue) {
              const mainInput = document.querySelector(`product-info-sticky .product-form__input:nth-child(${index}) input[data-option-value-id="${optionValue}"]`);
              if(mainInput) {
                if(!mainInput.checked) {
                 mainInput.checked = true;
                 mainInput.dispatchEvent(new Event("change", { bubbles: true }));
                }
              }
            }
          });

          this.handledropDown();

          this.differentShades?.getData(productUrl, variant);

          this.checkVariantFilters();
          this.attachVariantFilters();

          if (typeof window.applyGlobalPromo === 'function') {
            window.applyGlobalPromo();
          }

                
        };
        
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);

      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery');
        const mediaGalleryDestination = html.querySelector(`media-gallery`);

        if (mediaGallerySource && mediaGalleryDestination) {
             mediaGallerySource.innerHTML = mediaGalleryDestination.innerHTML;
           document.dispatchEvent(new CustomEvent('productScript:init'));
        }

       //============ FOR PDP
        if(typeof window?.videowiseProxy?.initialization == 'function') {
           window.videowiseProxy.initialization();
        }

        //============ FOR PLP
        if(typeof window.resetVideowiseProduct == 'function') {
          window.resetVideowiseProduct();
        }
        
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get differentShades() {
        return document.querySelector(`different-shades`);
      }
    }

  );
}

window.pswpMediaPosition = 0;

function initGTMEvents({ target }) {
  let event;
  const productTitle = document.querySelector("[js-product-info-wrapper]")?.getAttribute("data-product-title");
  if (target.closest(".quick-add-modal__content")) {
    event = "quick_shop";
  } else {
    event = "pdp_click";
  }

  // PDP Click - Shade Swatch
  if(target.hasAttribute("js-shade-swatch") || target.closest("[js-shade-swatch]")) {
    const shade = target.hasAttribute("js-shade-swatch") ? target.getAttribute("data-value") : target.closest("[js-shade-swatch]").getAttribute("data-value");

    window.dataLayer.push({
      event: event,
      click_type: 'Shade Swatch', 
      component_name: 'PDP / Buy Box',
      component_id: undefined,
      link_text: shade,
      link_path: undefined,
      product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Shade Dropdown
  if (target.classList.contains("js-dropdown-item") || target.closest("[js-dropdown-item]")) {
    const shade = target.classList.contains("js-dropdown-item") ? target.getAttribute("data-title") : target.closest("[js-dropdown-item]").getAttribute("data-title");
    window.dataLayer.push({
      event: event,
      click_type: 'Shade Dropdown', 
      component_name: 'PDP / Buy Box',
      component_id: undefined,
      link_text: shade,
      link_path: undefined,
       product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  }

    // PDP Click - How to Apply Inner Link 
  if (target.closest('.Product_object_all_button_main_new a')) {
    const link = target.closest('.Product_object_all_button_main_new a');
    const linkText = link.textContent?.trim();
    const linkPath = link.getAttribute('href');

    window.dataLayer.push({
      event: 'pdp_click',
      click_type: 'Link', 
      component_name: "PDP / How to Apply",
      component_id: "undefined",
      link_text: linkText || undefined,
      link_path: linkPath || undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  }

  // PDP Click - Accordion
  if(target.classList.contains("question")) {
    const accordionHeaderLabel = target.textContent;
    if(target.closest(".open")) {
      window.dataLayer.push({
        event: event,
        click_type: 'Accordion', 
        component_name: 'PDP / Buy Box',
        component_id: undefined,
        link_text: accordionHeaderLabel || undefined,
        link_path: undefined,
        product_name: product.title || undefined,
        collection_name: undefined,
        slide_index: undefined,
        active_state: undefined
      });
    }
  };

  // PDP Click - FAQ Question
  if(target.classList.contains("question_inner")) {
    const accordionHeaderLabel = target.textContent;
    if(target.parentElement.classList.contains("open")) {
      window.dataLayer.push({
        event: event,
        click_type: 'FAQ Question', 
        component_name: 'PDP / Buy Box',
        component_id: undefined,
        link_text: accordionHeaderLabel,
        link_path: undefined,
        product_name: product.title || undefined,
        collection_name: undefined,
        slide_index: undefined,
        active_state: undefined
      });
    }
  };

  // PDP Click - View Ingredients
  if(target.classList.contains("View_full_ingredients_list_popup_open_new")) {
    const btnLabel = target.textContent;
    window.dataLayer.push({
      event: event,
      click_type: 'Full Ingredients',
      component_name: 'PDP / Buy Box',
      component_id: undefined, 
      link_text: btnLabel,
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Shade Finder Rec
  if(target.classList.contains("hue-shade-finder")) {
    const btnLabel = target.textContent;
    window.dataLayer.push({
      event: event,
      click_type: 'Hue Shade Finder', 
      component_name: 'PDP / Buy Box',
      component_id: undefined, 
      link_text: btnLabel,
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Shade Finder Button
    if(target.matches(".Meta_find_my_shade_inner_new button")) {
    const btnLabel = target.textContent;
    window.dataLayer.push({
      event: event,
      click_type: 'Hue Shade Finder', 
      component_name: 'PDP / Buy Box',
      component_id: undefined, 
      link_text: btnLabel,
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Thumbnail Images
  if(target.classList.contains("thumbnail-list__item") || target.closest(".thumbnail-list__item")) {
    const thumbnail = target.classList.contains("thumbnail-list__item") ? target : target.closest(".thumbnail-list__item");
    let mediaPosition;
    const alt = thumbnail.querySelector("img").getAttribute("alt");
    const SliderComponent = document.querySelector(".main-product-carousel");
    if(SliderComponent) {
      const activeSlide = SliderComponent.querySelector(".swiper-slide-active");
      mediaPosition = parseInt(activeSlide?.getAttribute("data-swiper-slide-index")) + 1;
    }
    window.dataLayer.push({
      event: event,
      click_type: 'Thumbnail Image', 
      component_name: 'PDP / Buy Box',
      component_id: undefined, 
      link_text: alt,
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: mediaPosition,
      active_state: undefined
    });
  };

  // PDP Click - Select Shades
  if(target.hasAttribute("js-select-shades-btn") || target.closest("[js-select-shades-btn]")) {
    window.dataLayer.push({
      event: event,
      click_type: 'Select Shades',
      component_name: 'PDP / Buy Box',
      component_id: undefined, 
      link_text: "Select shades",
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - View Full Details
  if(target.hasAttribute("js-view-full-btn") || target.closest("[js-view-full-btn]")) {
    const btn = target.hasAttribute("js-view-full-btn") ? target : target.closest("[js-view-full-btn]");
    window.dataLayer.push({
      event: event,
      click_type: 'View Full Details', 
      link_text: btn.innerText,
      link_path: undefined,
      product_name: product.title || undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Shopify Product Recs
  if(target.hasAttribute("js-related-product-item") || target.closest("[js-related-product-item]")) {
    const productCard = target.hasAttribute("js-related-product-item") ? target : target.closest("[js-related-product-item]");
    window.dataLayer.push({
      event: "pdp_click",
      click_type: 'Product Recs', 
      component_name: 'PDP / Product Recs',
      component_id: undefined,
      link_text: productCard.getAttribute('data-title'),
      link_path: productCard.getAttribute('data-href'),
      product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Visually Product Recs
  if(target.classList.contains("vsly-product-tile") || target.closest(".vsly-product-tile")) {
    const card = target.classList.contains("vsly-product-tile") ? target : target.closest(".vsly-product-tile");
    window.dataLayer.push({
      event: "pdp_click",
      click_type: 'Visually - Product Recs', 
      component_name: 'PDP / Product Recs',
      component_id: undefined,
      link_text: card.querySelector('.vsly-product-title-section')?.innerText,
      link_path: card.getAttribute('href'),
      product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Comparison Chart 
  if(target.hasAttribute("js-product-meta-compare-link") || target.closest("[js-product-meta-compare-link]")) {
    const mainSection = target.closest(".shopify-section");
    const card = target.hasAttribute("js-product-meta-compare-link") ? target : target.closest("[js-product-meta-compare-link]");
    window.dataLayer.push({
      event: "pdp_click",
      click_type: 'Comparison Chart', 
      component_name: 'PDP / Comparison Chart',
      component_id: undefined,
      link_text: card.getAttribute("data-product-title"),
      link_path: card.getAttribute('href'),
      section: mainSection.querySelector(".Product_meta_compare_list_innertitle_new")?.innerText || "Shop & Compare",
      product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Comparison Chart 
  if(target.classList.contains("compare-list-quick-btn") || target.closest(".compare-list-quick-btn")) {
    const mainSection = target.closest(".shopify-section");
    const card = target.closest(".Product_meta_compare_list_innerloops_mainboxs_new");
    const anchor = card.querySelector("[js-product-meta-compare-link]");
    window.dataLayer.push({
      event: "pdp_click",
      click_type: 'Comparison Chart', 
      component_name: 'PDP / Comparison Chart',
      component_id: undefined,
      link_text: "shop now",
      link_path: anchor.getAttribute('href'),
      section: mainSection.querySelector(".Product_meta_compare_list_innertitle_new")?.innerText || "Shop & Compare",
      product_name: productTitle,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  };

  // PDP Click - Image Carousel Next
   if (target.classList.contains("swiper-button-next") || target.closest(".swiper-button-next")) {
    const SliderComponent = target.closest("slider-component");
    if(SliderComponent) {
      const activeSlide = SliderComponent.querySelector(".swiper-slide-active");
      const mediaPosition = parseInt(activeSlide?.getAttribute("data-swiper-slide-index")) + 1;
      const alt = activeSlide.querySelector("img").getAttribute("alt") || SliderComponent.querySelector("[js-product-title]").innerText;
  
      window.dataLayer.push({
          event: event,
          click_type: 'Image Carousel Icon',
          component_name: 'PDP / Buy Box',
          component_id: undefined, 
          link_text: alt,
          link_path: undefined,
          product_name: productTitle,
          collection_name: undefined,
          slide_index: mediaPosition,
          active_state: undefined
      });
    }
  };

  // PDP Click - Image Carousel Prev
  if (target.classList.contains("swiper-button-prev") || target.closest(".swiper-button-prev")) {
    const SliderComponent = target.closest("slider-component");
    if(SliderComponent) {
      const activeSlide = SliderComponent.querySelector(".swiper-slide-active");
      const mediaPosition = parseInt(activeSlide?.getAttribute("data-swiper-slide-index")) + 1;
      const alt = activeSlide.querySelector("img").getAttribute("alt") || SliderComponent.querySelector("[js-product-title]").innerText;

      window.dataLayer.push({
          event: event,
          click_type: 'Image Carousel Icon',
          component_name: 'PDP / Buy Box',
          component_id: undefined, 
          link_text: alt,
          link_path: undefined,
          product_name: productTitle,
          collection_name: undefined,
          slide_index: mediaPosition,
          active_state: undefined
      });
    }
  }

    // PDP Click - Zoomed Image Carousel Next
   if (target.classList.contains("pswp__button--next") || target.closest(".pswp__button--next")) {
      window.dataLayer.push({
          event: event,
          click_type: 'Image Carousel Zoom Icon',
          component_name: 'PDP / Buy Box',
          component_id: undefined, 
          link_text: undefined,
          link_path: undefined,
          product_name: productTitle,
          collection_name: undefined,
          slide_index: undefined,
          active_state: undefined
      });
  };

      // PDP Click - Zoomed Image Carousel Prev
   if (target.classList.contains("pswp__button--prev") || target.closest(".pswp__button--prev")) {
      window.dataLayer.push({
          event: event,
          click_type: 'Image Carousel Zoom Icon',
          component_name: 'PDP / Buy Box',
          component_id: undefined, 
          link_text: undefined,
          link_path: undefined,
          product_name: productTitle,
          collection_name: undefined,
          slide_index: undefined,
          active_state: undefined
      });
  };
  

  // PDP Click - Pair It With
  if (target.matches('.vsly-header-LG-2-0 button')) {
    const activeState = $('.vsly-header-LG-2-0').find('.active').first().text().trim();
    window.dataLayer.push({
        event: "pdp_click",
        click_type: "Visually - Pair It With",
        component_name: 'PDP / Pair It With',
        component_id: undefined,
        link_text: target.innerText.trim(),
        link_path: target.getAttribute('href') || undefined,
        product_name: productTitle,
        collection_name: undefined,
        slide_index: undefined,
        active_state: undefined
    });
  };

  // PDP Click - Pair It With
  if (target.tagName == "A" && target.classList.contains(".vsly-laura-custom-sol-rec-product-section")) {
    const card = target.closest(".vsly-laura-custom-sol-rec-parent");
    const anchor = card.querySelector("a.vsly-laura-custom-sol-rec-product-section");
    const activeState = $('.vsly-header-LG-2-0').find('.active').first().text().trim();
    window.dataLayer.push({
        event: "pdp_click",
        click_type: "Visually - Pair It With",
        component_name: 'PDP / Pair It With',
        component_id: undefined,
        link_text: anchor.getAttribute("aria-label"),
        link_path: anchor.getAttribute('href') || undefined,
        product_name: productTitle,
        collection_name: undefined,
        slide_index: undefined,
        active_state: activeState
    });
  };

  // PDP Click - Pair It With
  if (target.closest("a.vsly-laura-custom-sol-rec-product-section")) {
    const card = target.closest(".vsly-laura-custom-sol-rec-parent");
    const anchor = card.querySelector("a.vsly-laura-custom-sol-rec-product-section");
    const activeState = $('.vsly-header-LG-2-0').find('.active').first().text().trim();
    window.dataLayer.push({
        event: "pdp_click",
        click_type: "Visually - Pair It With",
        component_name: 'PDP / Pair It With',
        component_id: undefined,
        link_text: anchor.getAttribute("aria-label"),
        link_path: anchor.getAttribute('href') || undefined,
        product_name: productTitle,
        collection_name: undefined,
        slide_index: undefined,
        active_state: activeState
    });
  }

  //PDP FAQ Link
  if(target.tagName === "A" && target.closest(".answer") && !target.classList.contains("View_full_ingredients_list_popup_open_new")) {
     window.dataLayer.push({
        event: event,
        click_type: "FAQ Link",
        component_name: 'PDP / Pair It With',
        component_id: undefined,
        link_text: target.innerText.trim(),
        link_path: target.getAttribute('href') || undefined,
        product_name: productTitle,
        collection_name: undefined,
        slide_index: undefined,
        active_state: activeState
    });
  }else {
    if(target.closest("a") && target.closest(".answer") && !target.classList.contains("View_full_ingredients_list_popup_open_new")) {
      const anchorEl = target.closest("a");
       window.dataLayer.push({
          event: event,
          click_type: "FAQ Link",
          component_name: 'PDP / Pair It With',
          component_id: undefined,
          link_text: target.innerText.trim(),
          link_path: target.getAttribute('href') || undefined,
          product_name: productTitle,
          collection_name: undefined,
          slide_index: undefined,
          active_state: activeState
      });
    }
  }

}

if (!window.bodyClickAttached) {
 document.addEventListener("click", initGTMEvents)
  window.bodyClickAttached = true;
}